import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.05 22.11"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.65 13.38v3.38l4.87 2.81-1.46 2.54 8-2.14-2.14-8-1.46 2.54-4.88-2.82Z",
  style: {"fill":"#00a28d"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m11.53 13.16 2.92-1.68V5.85h2.93L11.53 0 5.68 5.85H8.6v5.63Z",
  style: {"fill":"#dc5283"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "m11.4 13.38-2.92-1.69-4.88 2.82L2.14 12 0 20l8 2.14-1.47-2.57 4.88-2.81Z",
  style: {"fill":"#4c58a2"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }